import TripleVector from '../../../../assets/icons/TripleVector';
import Checkbox from '../../../general/Checkbox/index';
import { Item, DivIcon, Title, Input, LeftSide, IconWrapper } from './styles';
import { ConfirmSubtask } from '../../../../assets/TaskModalIcons/ConfirmSubtask';
import { useState } from 'react';
import { useEffect } from 'react';
import Close from '../../../../assets/icons/Close';

const ListItem = ({
  item,
  current,
  setCurrent,
  updateSubtask,
  deleteSubtask,
  status,
}) => {
  const reset = () => setCurrent({ id: '', title: '', checked: false });

  const handleEditMode = () =>
    status !== 'done'
      ? current.id !== item.id
        ? setCurrent(item)
        : reset()
      : null;

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') return !isChange ? handleConfirm() : reset();
  };

  const [hover, setHover] = useState(false);

  const [edit, setEdit] = useState({
    title: current.title,
  });

  const handleConfirm = () => {
    updateSubtask({
      id: item.id,
      checked: item.checked,
      title: edit.title,
    }).then((res) => {
      reset();
    });
  };

  const handleDelete = () => {
    if (status !== 'done')
      deleteSubtask({
        id: item.id,
      }).then((res) => {});
  };

  const isChange =
    JSON.stringify({ title: edit.title }) ===
    JSON.stringify({ title: current.title });

  useEffect(() => {
    if (current.id !== item.id)
      setEdit({
        title: item.title,
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [current]);

  return (
    <>
      <Item>
        <LeftSide>
          <DivIcon>
            <TripleVector onClick={handleEditMode} />
          </DivIcon>
          <Checkbox
            checked={item.checked}
            onChange={() => {
              if (status !== 'done')
                updateSubtask({
                  id: item.id,
                  title: item.title,
                  checked: !item.checked,
                });
            }}
          />
          {current.id === item.id ? (
            <>
              <Input
                maxLength={35}
                value={edit.title}
                type="text"
                onChange={(e) => {
                  setEdit({ title: e.target.value });
                }}
                onKeyDown={handleKeyDown}
              />
              <ConfirmSubtask
                style={{
                  marginLeft: '0.5rem',
                  cursor: 'pointer',
                  visibility: !isChange ? 'visible' : 'hidden',
                }}
                onClick={handleConfirm}
                hover={hover}
                onMouseEnter={() => {
                  setHover(true);
                }}
                onMouseLeave={() => {
                  setHover(false);
                }}
              />
            </>
          ) : (
            <>
              <Title
                onClick={current.id !== item.id ? () => handleEditMode() : null}
              >
                {item.title}
              </Title>
              <IconWrapper className="close-icon-subtask">
                {status !== 'done' ? (
                  <Close
                    onClick={handleDelete}
                    style={{ cursor: 'pointer' }}
                    height={'0.8rem'}
                  />
                ) : null}
              </IconWrapper>
            </>
          )}
        </LeftSide>
        {/* <RightSide
          onClick={() => console.log('Modificar itens renderizados a direita!')}
        >
          <MenssageText />
          <RightSideText>Comentários</RightSideText>
          <ArrowRightMTask />
        </RightSide> */}
      </Item>
    </>
  );
};

export default ListItem;
